//opens the first review section on load

function logReviewButtons() {
  const reviewsContainer = document.querySelector('reviewsio-product-reviews-widget');
  if (!reviewsContainer) {
    return;
  }

  setTimeout(() => {
    try {
      const buttons = reviewsContainer.querySelectorAll('.ElementsWidget-prefix .R-TextBody');
      buttons.forEach((button) => {
        const clickableSection = button.nextSibling;
        if (!clickableSection) return;

        const innerDiv = clickableSection.querySelector('div');
        if (innerDiv?.innerHTML === 'Be the first to write a review') {
          setTimeout(() => {
            try {
              clickableSection.click();
            } catch (clickErr) {
              console.error('Failed to click review section:', clickErr);
            }
          }, 0);
        }
      });
    } catch (err) {
      console.error('Error processing review buttons:', err);
    }
  }, 300);
}

document.addEventListener('DOMContentLoaded', logReviewButtons);
